(function () {
  if (window.__zumzzCartUpsellFixLoaded) return;
  window.__zumzzCartUpsellFixLoaded = true;

  const selector =
    'cart-drawer-upsell .upsell-toggle-btn, cart-drawer-upsell .upsell__add-btn';

  function announce(cartDrawer, message, isError) {
    let status = cartDrawer.querySelector('#CartUpsellStatus');

    if (!status) {
      status = document.createElement('div');
      status.id = 'CartUpsellStatus';
      status.className = 'visually-hidden';
      status.setAttribute('role', isError ? 'alert' : 'status');
      status.setAttribute('aria-live', isError ? 'assertive' : 'polite');
      cartDrawer.appendChild(status);
    }

    status.setAttribute('role', isError ? 'alert' : 'status');
    status.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    status.textContent = '';
    window.requestAnimationFrame(() => {
      status.textContent = message;
    });
  }

  function renderCartSections(cartDrawer, sections) {
    const parser = new DOMParser();
    const currentDrawer = cartDrawer.querySelector('#CartDrawer');
    const drawerHtml = sections['cart-drawer'];

    if (!currentDrawer || !drawerHtml) return false;

    const drawerDocument = parser.parseFromString(drawerHtml, 'text/html');
    const nextDrawer = drawerDocument.querySelector('#CartDrawer');
    if (!nextDrawer) return false;

    // Body and footer must always come from the same Shopify response. Updating
    // them separately can leave an old subtotal beside newly rendered lines.
    currentDrawer.replaceChildren(
      ...Array.from(nextDrawer.childNodes, (node) => document.importNode(node, true))
    );

    cartDrawer.classList.remove('is-empty');
    cartDrawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof cartDrawer.close === 'function') {
      overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }

    const bubbleHtml = sections['cart-icon-bubble'];
    const currentBubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && currentBubble) {
      const bubbleDocument = parser.parseFromString(bubbleHtml, 'text/html');
      const nextBubble = bubbleDocument.querySelector('#cart-icon-bubble .shopify-section')
        || bubbleDocument.querySelector('.shopify-section');
      if (nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;
    }

    document.dispatchEvent(new CustomEvent('cartQuantityUpdated', { bubbles: true }));
    return true;
  }

  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest(selector);
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      const upsell = button.closest('cart-drawer-upsell');
      const form = upsell && upsell.querySelector('form[action*="/cart/add"]');
      const cartDrawer = document.querySelector('cart-drawer');
      if (!form || !cartDrawer) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('loading');

      try {
        const formData = new FormData(form);
        formData.set('sections', 'cart-drawer,cart-icon-bubble');
        formData.set('sections_url', window.location.pathname);

        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const data = await response.json();

        if (!response.ok || data.status || !data.sections || !data.sections['cart-drawer']) {
          throw new Error(data.description || data.message || 'Proizvod nije dodan u košaricu.');
        }

        if (!renderCartSections(cartDrawer, data.sections)) {
          throw new Error('Košarica se nije mogla osvježiti. Osvježite stranicu i pokušajte ponovno.');
        }

        announce(cartDrawer, 'Proizvod je dodan u košaricu.', false);
      } catch (error) {
        console.error('[Zumzz cart upsell]', error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
        announce(cartDrawer, error.message || 'Proizvod nije dodan. Pokušajte ponovno.', true);
      }
    },
    true
  );
})();
